import React from 'react';
import { Button } from 'antd';
import s from './s.modules.less';
import ChannelIcon, { EChannelIcon } from 'components/ChannelIcon';
import { TITLE, CONFIG } from './constants';

type Props = {
    // opens the "How to use your review link" walkthrough from step 2.
    // Required on purpose — an optional handler silently hides the CTA.
    onOpenReviewGuide: () => void;
};

// Channel icons for the step 2 chips — same Figma set the walkthrough uses.
const CHIP_ICONS: Record<string, EChannelIcon> = {
    'In-app message': EChannelIcon.CHAT,
    Text: EChannelIcon.CHAT_ALT,
    Email: EChannelIcon.MAIL,
    'After-visit summary': EChannelIcon.DOC,
};

const Features: React.FC<Props> = ({ onOpenReviewGuide }) => {
    return (
        <div className={s.wrap}>
            <h2 className={s.title}>{TITLE}</h2>
            <div className={s.list}>
                {CONFIG.map((configItem, inx) => {
                    return (
                        <div className={s.item} key={configItem.title}>
                            <div className={s.left}>
                                <h3 className={s.subTitle}>
                                    <span className={s.step}>Step {inx + 1}</span>
                                    {configItem.title}
                                </h3>
                                <ul className={s.description}>
                                    {configItem.tips.map((val: string) => {
                                        return (
                                            <li key={val}>
                                                {/* eslint-disable-next-line react/no-danger */}
                                                <div dangerouslySetInnerHTML={{ __html: val }} />
                                            </li>
                                        );
                                    })}
                                </ul>
                                {configItem.chips && (
                                    <div className={s.chips}>
                                        {configItem.chips.map((chip: string) => (
                                            <span className={s.chip} key={chip}>
                                                <ChannelIcon type={CHIP_ICONS[chip]} />
                                                {chip}
                                            </span>
                                        ))}
                                    </div>
                                )}
                                {configItem.cta && (
                                    <Button type="primary" className={s.cta} onClick={onOpenReviewGuide}>
                                        {configItem.cta}
                                        <svg
                                            viewBox="0 0 16 16"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        >
                                            <line x1="3" y1="8" x2="12" y2="8" />
                                            <polyline points="8.5 4.5 12 8 8.5 11.5" />
                                        </svg>
                                    </Button>
                                )}
                            </div>
                            {configItem.image && <div className={s.right}>{configItem.image}</div>}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default Features;
